module.exports = __webpack_public_path__ + "img/type.48fc3d43.png";